import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "o-searchAgent" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = {
  key: 0,
  ref: "searhAgentTooltip",
  class: "o-searchAgent__tooltip"
}
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = {
  key: 0,
  class: "a-paragraph"
}
const _hoisted_7 = {
  key: 1,
  class: "o-searchAgent__tooltipText"
}
const _hoisted_8 = { class: "a-paragraph" }
const _hoisted_9 = { key: "searchAgentOptions" }
const _hoisted_10 = { class: "a-heading2 o-panel__heading" }
const _hoisted_11 = { class: "o-panel--spacedChildrenLarge" }
const _hoisted_12 = { class: "a-paragraph" }
const _hoisted_13 = { class: "a-card o-panel--spacedChildrenSmall" }
const _hoisted_14 = { class: "o-tags o-searchFilters__tags" }
const _hoisted_15 = { class: "m-tag__text" }
const _hoisted_16 = { class: "m-tag isDisabled" }
const _hoisted_17 = {
  key: 0,
  class: "m-tag__text"
}
const _hoisted_18 = {
  key: 1,
  class: "m-tag__text"
}
const _hoisted_19 = {
  key: 2,
  class: "m-tag__text"
}
const _hoisted_20 = { class: "o-panel--spacedChildrenSmall" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "o-buttons o-subPanel__actions" }
const _hoisted_23 = ["textContent"]
const _hoisted_24 = ["href"]
const _hoisted_25 = ["textContent"]
const _hoisted_26 = {
  key: "searchAgentNameSuccess",
  class: "o-panel"
}
const _hoisted_27 = { class: "a-confirmationNotice u-align-center u-justify-center" }
const _hoisted_28 = { class: "a-confirmationNotice__checkmark" }
const _hoisted_29 = { class: "o-panel--spacedChildrenMedium" }
const _hoisted_30 = ["textContent"]
const _hoisted_31 = { class: "a-paragraph u-text-center" }
const _hoisted_32 = { class: "a-card" }
const _hoisted_33 = { class: "o-panel--spacedChildrenSmall" }
const _hoisted_34 = ["textContent"]
const _hoisted_35 = { class: "o-tags o-searchFilters__tags" }
const _hoisted_36 = { class: "m-tag__text" }
const _hoisted_37 = { class: "m-tag isDisabled" }
const _hoisted_38 = {
  key: 0,
  class: "m-tag__text"
}
const _hoisted_39 = {
  key: 1,
  class: "m-tag__text"
}
const _hoisted_40 = {
  key: 2,
  class: "m-tag__text"
}
const _hoisted_41 = { class: "u-text-center" }
const _hoisted_42 = ["href", "textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_m_input = _resolveComponent("m-input")!
  const _component_portal = _resolveComponent("portal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isDrawingArea)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["m-button hasIcon o-searchAgent__button", {
                    'invalid m-button--shadowed': $options.hasInvalidFilters,
                    valid: !$options.hasInvalidFilters,
                }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.onClick && $options.onClick(...args)))
          }, [
            _createElementVNode("span", {
              class: "m-button__text",
              textContent: _toDisplayString($props.searchAgent.button.text)
            }, null, 8 /* PROPS */, _hoisted_3),
            _createVNode(_component_a_icon, {
              class: "m-button__icon",
              name: $props.searchAgent.button.icon
            }, null, 8 /* PROPS */, ["name"])
          ], 2 /* CLASS */),
          ($options.hasInvalidFilters)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.closeTooltip && $options.closeTooltip(...args))),
                  class: "o-searchAgent__closeButton",
                  "aria-label": $props.searchAgent.tooltip.close
                }, [
                  _createVNode(_component_a_icon, { name: "close" })
                ], 8 /* PROPS */, _hoisted_5),
                _createElementVNode("div", null, [
                  ($data.invalidText)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($data.invalidText), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("h2", {
                          class: _normalizeClass({
                                'a-heading3': $data.isDesktop,
                                'a-heading2': !$data.isDesktop,
                            })
                        }, _toDisplayString($props.searchAgent.tooltip.headline), 3 /* TEXT, CLASS */),
                        _createElementVNode("span", _hoisted_8, _toDisplayString($props.searchAgent.tooltip.content), 1 /* TEXT */)
                      ]))
                ])
              ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    ($options.showSearchAgentOverlay)
      ? (_openBlock(), _createBlock(_component_portal, {
          key: 1,
          to: "modal"
        }, {
          default: _withCtx(() => [
            _createVNode(_Transition, {
              name: `o-panel--${$data.currentDirection}`
            }, {
              default: _withCtx(() => [
                (!_ctx.currentPanel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("h2", _hoisted_10, _toDisplayString($props.searchAgent.stepOne.headline), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("p", _hoisted_12, _toDisplayString($props.searchAgent.stepOne.content), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_m_input, {
                            modelValue: $data.form.name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.form.name) = $event)),
                            class: "o-searchFilters__input",
                            label: $props.searchAgent.stepOne.nameLabel,
                            error: $data.errors.name,
                            onInput: _cache[3] || (_cache[3] = ($event: any) => ($options.updateInput('name', $event)))
                          }, null, 8 /* PROPS */, ["modelValue", "label", "error"]),
                          _createElementVNode("div", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, tagIndex) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "m-tag isDisabled",
                                key: `filter-${tagIndex}`
                              }, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(filter.label), 1 /* TEXT */)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */)),
                            _createElementVNode("span", _hoisted_16, [
                              (_ctx.query)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.query), 1 /* TEXT */))
                                : (_ctx.area && _ctx.area.length)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Tegnet område"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_19, "Aktuelt kortudsnit"))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          ($props.searchAgent.consent.purposeText)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "a-small a-small--allowBreak o-fields__field",
                                innerHTML: $props.searchAgent.consent.purposeText
                              }, null, 8 /* PROPS */, _hoisted_21))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_22, [
                            ($props.searchAgent.isLoggedIn)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  ref: "submit",
                                  type: "submit",
                                  class: _normalizeClass(["m-button m-button--fullWidth", { isLoading: $data.isLoading }]),
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.onSubmit(false)))
                                }, [
                                  _createElementVNode("span", {
                                    class: "m-button__text",
                                    textContent: _toDisplayString(
                                            $props.searchAgent.stepOne.saveButtonText
                                        )
                                  }, null, 8 /* PROPS */, _hoisted_23)
                                ], 2 /* CLASS */))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  href: $data.loginUrl,
                                  class: "m-button m-button--fullWidth",
                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.onLogin && $options.onLogin(...args)))
                                }, [
                                  _createElementVNode("span", {
                                    class: "m-button__text",
                                    textContent: _toDisplayString(
                                            $props.searchAgent.stepOne
                                                .signupLoginButtonText
                                        )
                                  }, null, 8 /* PROPS */, _hoisted_25)
                                ], 8 /* PROPS */, _hoisted_24))
                          ])
                        ])
                      ])
                    ]))
                  : (_ctx.currentPanel === 'searchAgentNameSuccess')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_a_icon, { name: "check" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("h2", {
                            class: "a-heading2 o-panel__heading u-text-center u-inline-auto",
                            textContent: _toDisplayString($props.searchAgent.stepThree.headline)
                          }, null, 8 /* PROPS */, _hoisted_30),
                          _createElementVNode("p", _hoisted_31, _toDisplayString($props.searchAgent.stepThree.content), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("p", {
                                class: "a-label a-label--secondary",
                                textContent: _toDisplayString(_ctx.agentName)
                              }, null, 8 /* PROPS */, _hoisted_34),
                              _createElementVNode("div", _hoisted_35, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, tagIndex) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    class: "m-tag isDisabled",
                                    key: `filter-${tagIndex}`
                                  }, [
                                    _createElementVNode("span", _hoisted_36, _toDisplayString(filter.label), 1 /* TEXT */)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */)),
                                _createElementVNode("span", _hoisted_37, [
                                  (_ctx.query)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.query), 1 /* TEXT */))
                                    : (_ctx.area && _ctx.area.length)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Tegnet område"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_40, "Aktuelt kortudsnit"))
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("a", {
                              class: "a-anchor a-anchor--secondary",
                              href: $props.searchAgent.stepThree.profileLinkUrl,
                              textContent: _toDisplayString($props.searchAgent.stepThree.profileLinkText),
                              target: "_blank"
                            }, null, 8 /* PROPS */, _hoisted_42)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
              ], undefined, true),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["name"])
          ], undefined, true),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}